import MainContent from './components/MainContainer/MainContainer'
import { AuthProvider } from './contexts/AuthorizationContext/AuthorizationProvider'

import './App.css'

const App = () => {
  return (
    <AuthProvider>
      <MainContent />
    </AuthProvider>
  )
}

export default App
